import moment from 'moment';

export const formatRunoutDate = (earliest?: number | null): string => {
  if (!earliest) {
    return 'N/A';
  }
  const m = moment(earliest);
  return m.isAfter(moment().add(1, 'year')) ? 'Over a year' : m.format('MM/DD/YYYY');
};
